<div>
  @if ((costElements$ | ngrxPush)?.length > 0) {
    <cdba-toggle-split-type-button
      [currentSplitType]="currentSplitType$ | ngrxPush"
      (toggleSplitType)="toggleSelectedSplitType()"
    ></cdba-toggle-split-type-button>
  }
</div>
